import React, { useState } from "react";
import moment from "moment";
import { RecordVoiceOverRounded } from "@material-ui/icons";

const ScheduledTripLegsValidator = (props) => {
  const record = props.data.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";

  /*
    Examples of validators - the record will have a copy of the working data
  */
  // if (!record.*code*) { 
  //   error = true;
  //   errorMessage = "Please select a valid code";
  // } else if (!moment(record.*date*).isValid()) {
  //   error = true;
  //   errorMessage = "Please enter a valid date";
  // } else if (moment(record.*date1*).isBefore(record.*date2*)) {
  //   error = true;
  //   errorMessage = "The '*date1 name*' date cannot be before the '*date2 name' date";
  // } else if (record.*number* <= 0) {
  //   error = true;
  //   errorMessage = "The *number field* must be greater than zero";
  // }   


  if (!error && !record.originAirportCode) {
    error = true;
    errorMessage = "'Origin Airport Code' is required";
  }
  if (!error && !record.destinationAirportCode) {
    error = true;
    errorMessage = "'Destination Airport Code' is required";
  }
  if (!error && record.transportType === 'PRIMARY' && !record.alternateAirportCode) {
    error = true;
    errorMessage = "'Alternate Airport Code' is required";
  }
  if (!error && !record.transportType) {
    error = true;
    errorMessage = "'Transport Type' is required";
  }
  if (!error && record.transportType === 'PRIMARY' && (!record.airlineCode || !record.flightNo)) {
    error = true;
    errorMessage = "'Flight No' is required";
  }
  if (!error && (isNaN(record.offsetDay) || isNaN(parseInt(record.offsetDay)))) {
    error = true;
    errorMessage = "'Offset Day' is not a valid number";
  }
  if (!error && (record.offsetDay < 0 || RecordVoiceOverRounded.offsetDay > 5)) {
    error = true;
    errorMessage = "'Offset Day' value must be between 0 and 5";
  }
  if (!error && !moment.utc(record.scheduledDepartureTimeUTC, 'HH:mm').isValid) {
    error = true;
    errorMessage = "'Departure Time' is an invalid time";
  }
  if (!error && !moment.utc(record.scheduledArrivalTimeUTC, 'HH:mm').isValid) {
    error = true;
    errorMessage = "'Arrival Time' is an invalid time";
  }

  const departureMoment = moment.utc(`2000-01-01 ${record.scheduledDepartureTimeUTC}`);
  const arrivalMoment = moment.utc(`2000-01-01 ${record.scheduledArrivalTimeUTC}`);
  if (arrivalMoment.isBefore(departureMoment)){
    arrivalMoment.add(1, 'day');
  }
  const diff = arrivalMoment.diff(departureMoment, 'minutes');

  if (!error && diff < 30) {
    error = true;
    errorMessage = "'Duration' time is too short";
  } 

  if (!error && !record.legType) {
    error = true;
    errorMessage = "'Leg Type' is required";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default ScheduledTripLegsValidator;
